import { Drawer } from "antd";
import { ReactNode } from "react";

interface DataGridFilterDrawerProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
}

export const DataGridFilterDrawer = ({ open, onClose, title = "فیلترها", children }: DataGridFilterDrawerProps) => {
  return (
    <Drawer open={open} onClose={onClose} title={title} width={320} placement="left">
      <div className="flex flex-col gap-4">{children}</div>
    </Drawer>
  );
};
